export function isInteractiveTarget(target) {
    const element = target instanceof HTMLElement
        ? target
        : target?.parentElement instanceof HTMLElement
            ? target.parentElement
            : null;
    if (!element) return false;
    return Boolean(
        element.closest("input")
        || element.closest("button")
        || element.closest("textarea")
        || element.closest("select")
        || element.closest("a")
        || element.closest("label")
    );
}

